import React from 'react';

import ear_icon from "../../images/ear_icon.svg";
import red_x from "../../images/red_x.svg";
import muted_icon from "../../images/muted_icon.svg";
import spinner from "../../images/spinner.svg";
import raiseHand from "../../images/ready-module/raiseHand.png";
import FaQuestion from 'react-icons/lib/fa/question-circle-o';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import {endUserSession} from '../../services/API';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import { GetBrandedAppName } from '../../services/BrandingService';
import { getCopyByGradeband } from '../../services/ThemingService';

//this is a function so that the copy can be populated at run time
export function getErrorModalTypes(){
  return {
    AUDIO: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.audio_error_text,
      image: ear_icon,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.restart,
      largeIcon: true,
    },
    MUTE: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.mute_error_text,
      image: muted_icon,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.im_ready,
    },
    ERROR: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.error_text,
      image: red_x,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.logout_and_restart,
      reload: true,
    },
    WEBGL_ERROR: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.webgl_error_text,
      image: red_x,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.restart,
      reload: true,
      webglError: true,
    },
    COMPAT: {
      speech: null,
      text: COPY_STRINGS.compat_error_text,
      image: red_x,
      title: COPY_STRINGS.browser_not_supported,
      button: COPY_STRINGS.logout,
      reload: true,
    },
    COMPAT_OS: {
      speech: null,
      text: COPY_STRINGS.compat_error_text_os,
      image: red_x,
      title: COPY_STRINGS.os_not_supported,
      button: COPY_STRINGS.logout,
      reload: true,
    },
    COMPAT_MOBILE: {
      speech: null,
      text: COPY_STRINGS.compat_error_text_mobile,
      image: red_x,
      title: COPY_STRINGS.mobile_not_supported,
      button: COPY_STRINGS.logout,
      reload: true,
    },
    COMPAT_IPAD: {
      speech: null,
      text: COPY_STRINGS.compat_error_text_ipad,
      image: red_x,
      title: COPY_STRINGS.browser_not_supported,
      button: COPY_STRINGS.logout,
      reload: true,
    },
    PRODUCT_ACCESS: {
      speech: null,
      text: COPY_STRINGS.product_access_disabled_text,
      image: red_x,
      title: COPY_STRINGS.product_access_disabled_title(GetBrandedAppName()),
      button: COPY_STRINGS.logout,
      reload: true,
      endSessionWhenNoRedirect: true,
    },
    IPAD: {
      speech: null,
      text: COPY_STRINGS.ipad_error_text(GetBrandedAppName()),
      image: red_x,
      title: "Your device is not supported",
      button: "ok",
      reload: true,
    },
    DISABLED: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.disabled_error_continue,
      image: muted_icon,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.im_ready,
      helpLink: "https://help.amiralearning.com/s/article/How-To-Always-Enable-the-Microphone"
    },
    DISABLED_REFRESH: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.disabled_error_text,
      image: muted_icon,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.logout,
      reload: true,
      helpLink: "https://help.amiralearning.com/s/article/How-To-Always-Enable-the-Microphone"
    },
    BLANK: {
      speech: getCopyByGradeband(COPY_STRINGS, 'kid_error_speech'),
      text: COPY_STRINGS.blank_error_text,
      image: ear_icon,
      title: COPY_STRINGS.raise_your_hand,
      button: COPY_STRINGS.logout,
      largeIcon: true,
    },
    NOSTORIES: {
      speech: getCopyByGradeband(COPY_STRINGS, 'no_stories_for_you'),
      text: getCopyByGradeband(COPY_STRINGS, 'no_stories_for_you_text'),
      title: getCopyByGradeband(COPY_STRINGS, 'all_stories_taken'),
      button: COPY_STRINGS.logout,
      reload: true,
    },
    COMPAT_NO_SPANISH: {
      speech: null,
      text: COPY_STRINGS.compat_error_no_spanish,
      image: red_x,
      title: COPY_STRINGS.os_not_supported,
      button: COPY_STRINGS.im_ready,
    },
    FATAL_STORY_FETCH_FAILURE: {
      speech: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories'),
      text: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_story_code'),
      image: red_x,
      title: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_title'),
      button: COPY_STRINGS.try_again
    },
    FATAL_REC_FETCH_FAILURE: {
      speech: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories'),
      text: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_rec_code'),
      image: red_x,
      title: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_title'),
      button: COPY_STRINGS.try_again
    },
    FATAL_PUT_ACTIVITY_FAILURE: {
      speech: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories'),
      text: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_put_activity_code'),
      image: red_x,
      title: getCopyByGradeband(COPY_STRINGS, 'error_fetching_stories_title'),
      button: COPY_STRINGS.try_again
    },
    PAUSED_FROM_BAD_NETWORK: {
      speech: getCopyByGradeband(COPY_STRINGS, 'paused_from_bad_network_speech'),
      image: spinner,
      title: getCopyByGradeband(COPY_STRINGS, 'paused_from_bad_network_title'),
      button: null,
      hugeIcon: true,
    },
    RESUME_FROM_BAD_NETWORK: {
      title: COPY_STRINGS.resume_from_bad_network_ready,
      button: COPY_STRINGS.resume_from_bad_network_continue,
    },
    AUDIO_INPUT_CHANGED_ERROR: {
      text: COPY_STRINGS.audio_input_changed_error_text,
      image: raiseHand,
      title: COPY_STRINGS.audio_input_changed_error_title,
      button: COPY_STRINGS.restart,
      giganticIcon: true,
      reload: true,
    },
  };
}



export class ErrorModal extends React.Component {
  constructor (props){
    super(props);
    this.logout = this.logout.bind(this);
  }

  componentDidMount(){
    if(this.props.speech && !this.props.skipSpeech){
      let speechProps = {
        textToSpeak: this.props.type.speech,
      };
      this.props.speech.speak(speechProps);
    }
  }

  logout(){
    if (this.props.type && this.props.type.reload) {
      if (this.props.returnUrl) {
        window.location.href = this.props.returnUrl;
        return;
      }

      const loginOrigin = localStorage.getItem("loginOrigin");
      if (loginOrigin) {
        window.location.href = loginOrigin;
      } else if (this.props.type.endSessionWhenNoRedirect) {
        // A bare reload re-runs the URL's SSO token login straight back into the same blocking
        // modal (ASSMNT-2567). endUserSession(true) closes an opener tab and sends SSO students to
        // /sessionEnded.html; any other session with no opener (non-SSO or sideloaded) still reloads.
        endUserSession(true);
      } else {
        window.location.reload();
      }
      return;
    }

    this.props.continue && this.props.continue();
  }

  render() {

    let iconClassName = this.props.type.largeIcon ? "icon" : "icon error";
    if (this.props.type.hugeIcon) {
      iconClassName = "hugeIcon";
    }

    if (this.props.type.giganticIcon) {
      iconClassName = "giganticIcon";
    }

    // TODO add links to help button
    return (
      <div className="restartModal">
        <div className="alert">{this.props.type.title}</div>
        {this.props.type.image &&
          <div className="iconContainer">
            <img className={iconClassName} src={this.props.type.image} alt=""/>
          </div>
        }
        <div className="explanation labelFontOverride">
          {this.props.type.text}
        </div>
        {this.props.type.button &&
          <div className="restartButton primaryButton" {...doNotUseAccessibleStaticElementInteractions({onClick: this.logout})}>{this.props.type.button}</div>
        }
        {this.props.type.helpLink &&
          <a href={this.props.type.helpLink} target="_blank" className="studentHelpButton">
            <FaQuestion size="22" className="errorModalHelpIcon" />
            Help
          </a>
        }
      </div>
    );
  }
}
